import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnChanges, Output, SimpleChanges, Type } from '@angular/core';
import { FormControl } from '@angular/forms';
import { IChatFormControl } from '@nimbus-global/features/chat-form/models/chat-form.model';

@Component({
  selector: 'nimbus-chat-form-control',
  standalone: false,
  templateUrl: './chat-form-control.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ChatFormControlComponent implements OnChanges {
  @Input({ required: true })
  public component: Type<IChatFormControl>;

  @Input({ required: true })
  public control: FormControl<string>;

  @Input()
  public required: boolean = false;

  @Output()
  public contextChanged = new EventEmitter<Record<string, string>>();

  public componentInputs: Record<string, unknown>;

  public ngOnChanges(changes: SimpleChanges): void {
    if (changes.component || changes.control || changes.required) {
      this.componentInputs = {
        control: this.control,
        required: this.required,
        contextChanged: (context: Record<string, string>): void => this.contextChanged.emit(context),
      };
    }
  }
}
